<template>
	<div>
		<!-- selection="multiple"
            :selected.sync="users_subscribed_selected" -->
		<q-table
			:data="users_subscribed"
			:columns="columns"
			:pagination.sync="server_pagination"
			@request="request"
			:loading="loading"
			row-key="id"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			class="q-mt-md"
			binary-state-sort
		>
			<template slot="top" slot-scope="props">
				<div class="col" />
				<q-btn
					color="tertiary"
					class="q-mr-sm"
					icon="far fa-file-download"
					:label="$t('download_guest_list')"
					@click="downloadGuestList"
					:disable="users_subscribed.length < 1 || !manageWebcasts"
				/>
				<!-- <q-btn color="negative" icon="far fa-ban" :label="$t('remove')" @click="removeUsers" class="q-mr-sm" v-if="users_subscribed_selected.length > 0"/> -->
			</template>

			<q-tr slot="header" slot-scope="props" :props="props">
				<!-- <q-th auto-width>
                    <q-checkbox v-model="props.selected" indeterminate-value="some" :disable="!manageWebcasts" />
                </q-th> -->

				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<q-tr slot="body" slot-scope="props">
				<!-- <q-td auto-width>
                    <q-checkbox color="primary" v-model="props.selected" :disable="!manageWebcasts" />
                </q-td> -->

				<q-td key="id" :props="props">
					{{ props.row.id }}
				</q-td>

				<q-td key="name" :props="props">
					{{ props.row.name }}
				</q-td>

				<q-td key="email" :props="props">
					{{ props.row.email }}
				</q-td>

				<q-td key="profile" :props="props">
					{{ translateProfiles(props.row.profile) }}
				</q-td>

				<!-- <q-td auto-width key="actions" :props="props">
                    <q-btn round flat icon="fal fa-trash" color="negative" @click="removeUser(props)" :disable="!manageWebcasts" >
                        <q-tooltip>
                            {{ $t('delete_tooltip')}}
                        </q-tooltip>
                    </q-btn>
                </q-td> -->
			</q-tr>
		</q-table>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="$router.push({ name: 'admin_webcasts' })"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'SubscribersTab',

	props: ['manageWebcasts'],

	data() {
		return {
			id_webcast: '',
			users_subscribed: [],
			users_subscribed_selected: [],
			columns: [
				{
					name: 'id',
					required: true,
					label: '#',
					align: 'left',
					field: 'id',
					sortable: false,
				},
				{
					name: 'name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'name',
					sortable: false,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: false,
				},
				{
					name: 'profile',
					required: true,
					label: 'profile',
					align: 'left',
					field: 'profile',
					sortable: false,
				},
				// {
				//     name: 'actions',
				//     required: true,
				//     label: '',
				//     align: 'right',
				//     field: 'actions',
				//     sortable: false,
				// }
			],
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 5,
				descending: false,
				sortBy: null,
			},
			loading: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			num_rows: 'datatable/num_rows',
			profiles: 'registration_lists/profiles',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '90vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},
	},

	methods: {
		request({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				search: this.filter_guests,
				ordering: order_by,
			}

			this.savePagination()

			this.$axios
				.get(
					`/admin_webcasts/webcasts/${this.id_webcast}/guests/?${this.$qs.stringify(
						data
					)}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count

					if (response.data.count > 0) {
						this.users_subscribed = response.data.results.map((e) => {
							let user = {
								id: e.list_users.id,
								name: e.list_users.name,
								email: e.list_users.email,
								profile: e.list_users.profile,
								selected: false,
							}
							return user
						})
					}
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		/* saveUsers() {
            this.$q.loading.show()

            let data = {
                users: this.users_subscribed.map(e => e.id).filter((user, id) => user.id !== id)
            }

            this.$axios.post(`/admin_webcasts/webcasts/${this.id_webcast}/guests/`, data, this.getHeader)
            .then(response => {

                this.$q.notify({
                    message: this.$t('subscribers_list_save_success'),
                    type: 'positive',
                    icon: 'fal fa-save'
                })

            })
            .catch(e => {
                console.log(e)

                this.$q.notify({
                    message: this.$t('subscribers_list_save_error'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })
            })
            .finally(() => {
                this.clearUsersSelection()
                this.$q.loading.hide()
                this.search = ''
            })
        },

        removeUser(props) {
            this.users_subscribed.splice(props.row.__index, 1)
            this.saveUsers()
        },

        removeUsers() {
            this.users_subscribed_selected.map(e => {
                this.users_subscribed = this.users_subscribed.filter(f => f.id !== e.id)
            })

            this.saveUsers()
        },

        clearUsersSelection() {
            this.users_subscribed_selected = []
            this.request({
                pagination: {
                    page: 1,
                    rowsNumber: 10,
                    rowsPerPage: 5,
                    descending: false,
                    sortBy: null
                }
            })
        },*/

		downloadGuestList() {
			let message = this.$t('generating_guest_list_download_message')
			this.$q.loading.show({
				message,
			})
			this.$axios
				.get(
					`/admin_webcasts/webcasts/${this.id_webcast}/guests/generate_report/`,
					this.getHeader
				)
				.then((response) => {
					this.forceFileDownload(response.data.path_url)
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		forceFileDownload(response) {
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
		},

		translateProfiles(value) {
			let profile = value.toUpperCase()
			let term = this.profiles.find((e) => e.translations[0].name.toUpperCase() === profile)
			if (term) {
				let translated = term.label.toLowerCase()
				return translated.charAt(0).toUpperCase() + translated.slice(1)
			} else return value
		},

		savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
		},

		loadPagination() {
			this.server_pagination.rowsPerPage = this.num_rows
		},
	},

	created() {
		this.loadPagination()
		this.id_webcast = this.$route.params.id

		this.request({
			pagination: this.server_pagination,
		})
	},
}
</script>

<style></style>
